import { render, staticRenderFns } from "./ApprovalAwait.vue?vue&type=template&id=38653d63&scoped=true&"
import script from "./ApprovalAwait.vue?vue&type=script&lang=js&"
export * from "./ApprovalAwait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38653d63",
  null
  
)

export default component.exports